import { render, staticRenderFns } from "./page-uid.vue?vue&type=template&id=bf641a32&"
import script from "./page-uid.vue?vue&type=script&lang=js&"
export * from "./page-uid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports